import React from 'react';
import './FocusSection.css';

const FocusSection: React.FC = () => (
  <section className="focus-section">
    <div className="focus-header">
      <h2 className="focus-title">
        Наши <span className="focus-gradient">стержневые компетенции</span>
      </h2>
      <p className="focus-description">
        Мы специализируемся на поиске конфиденциальных и закрытых данных, превращая их в понятные отчёты для вашего бизнеса. В фокусе — компенсации топ-менеджеров, управленцев среднего звена и уникальных специалистов, рыночные метрики, все, что невозможно и очень сложно получить из открытых источников
      </p>
    </div>
    <div className="pyramid-container">
      <div className="pyramid-level level-ceo" title="Поиск и анализ данных по первым лицам компаний">CEO</div>
      <div className="pyramid-level level-top" title="Закрытая информация о топ-менеджменте и их вознаграждениях">Топ-менеджмент</div>
      <div className="pyramid-level level-middle" title="Критично важные специалисты, зарплатные данные и конкуренция за кадры">Менеджмент среднего звена</div>
      <div className="pyramid-level level-line" title="Любая уникальная информация, необходимая для принятия ключевых решений">Линейные сотрудники</div>
    </div>
  </section>
);

export default FocusSection; 